import { UseCase } from './UseCase';
export class DrawUseCase extends UseCase {
    constructor(applicationServices) {
        super();
        this.applicationServices = applicationServices;
    }
    execute(event) {
        return event.interfaceEntityState
            ? this.applicationServices.interface.updateEntityInterfaceState(event.id, event.interfaceEntityState)
            : this.applicationServices.interface.removeEntityInterfaceState(event.id);
    }
}
